/* ============================================================
   PRAISETHEHIGHEST — Theme JavaScript
   ============================================================ */

(function () {
  'use strict';

  /* ============================================================
     Helpers
     ============================================================ */

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function formatMoney(cents, currency) {
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency || 'GBP',
        minimumFractionDigits: 2
      }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }

  /* ============================================================
     Mobile Menu
     ============================================================ */

  const menuToggle = document.querySelector('.site-header__hamburger');
  const mobileMenu = document.getElementById('mobile-menu');
  const menuOverlay = document.getElementById('mobile-menu-overlay');
  const menuClose = document.querySelector('.mobile-menu__close');

  function openMenu() {
    mobileMenu.classList.add('is-open');
    mobileMenu.setAttribute('aria-hidden', 'false');
    menuOverlay.style.display = 'block';
    setTimeout(() => menuOverlay.classList.add('is-visible'), 10);
    document.body.style.overflow = 'hidden';
  }

  function closeMenu() {
    mobileMenu.classList.remove('is-open');
    mobileMenu.setAttribute('aria-hidden', 'true');
    menuOverlay.classList.remove('is-visible');
    setTimeout(() => { menuOverlay.style.display = 'none'; }, 250);
    document.body.style.overflow = '';
  }

  if (menuToggle) menuToggle.addEventListener('click', openMenu);
  if (menuClose) menuClose.addEventListener('click', closeMenu);
  if (menuOverlay) menuOverlay.addEventListener('click', closeMenu);

  /* ============================================================
     Cart API helpers
     ============================================================ */

  async function addToCart(variantId, quantity) {
    quantity = quantity || 1;
    try {
      const res = await fetch(window.routes.cart_add_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: quantity })
      });
      if (!res.ok) throw new Error('Cart add failed');
      await res.json();
      await fetchAndRenderCart();
      openCartDrawer();
    } catch (err) {
      console.error(err);
    }
  }

  function updateCartCount(count) {
    const counts = document.querySelectorAll('.cart-count');
    counts.forEach(el => {
      el.textContent = count;
      el.style.display = count > 0 ? 'inline-flex' : 'none';
    });
  }

  async function fetchCart() {
    const res = await fetch('/cart.js');
    return res.json();
  }

  /* ============================================================
     Cart Drawer
     ============================================================ */

  function openCartDrawer() {
    const drawer = document.getElementById('CartDrawer');
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'false');
    drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    const closeBtn = drawer.querySelector('.cart-drawer__close');
    if (closeBtn) setTimeout(() => closeBtn.focus(), 320);
  }

  function closeCartDrawer() {
    const drawer = document.getElementById('CartDrawer');
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'true');
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  async function fetchAndRenderCart() {
    try {
      const cart = await fetchCart();
      renderCartDrawer(cart);
      updateCartCount(cart.item_count);
    } catch (err) {
      console.error(err);
    }
  }

  function renderCartDrawer(cart) {
    const body = document.getElementById('CartDrawerBody');
    const footer = document.getElementById('CartDrawerFooter');
    if (!body) return;

    if (!cart.item_count) {
      body.innerHTML = '<div class="cart-drawer__empty"><p>Your cart is empty</p></div>';
      if (footer) footer.style.display = 'none';
      return;
    }

    let html = '';
    cart.items.forEach((item, index) => {
      const lineIndex = index + 1;
      const showVariant = item.variant_title && item.variant_title !== 'Default Title';
      const variantHtml = showVariant
        ? `<p class="cart-drawer__item-variant">Size: ${escapeHtml(item.variant_title)}</p>`
        : '';
      const imgHtml = item.image
        ? `<img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.product_title)}" class="cart-drawer__item-img" loading="lazy" width="80" height="100">`
        : `<div class="cart-drawer__item-img-placeholder"></div>`;

      html += `
        <div class="cart-drawer__item" data-line-index="${lineIndex}">
          <a href="${escapeHtml(item.url)}" class="cart-drawer__item-img-wrap" tabindex="-1">${imgHtml}</a>
          <div class="cart-drawer__item-info">
            <a href="${escapeHtml(item.url)}" class="cart-drawer__item-title">${escapeHtml(item.product_title)}</a>
            ${variantHtml}
            <p class="cart-drawer__item-price">${formatMoney(item.final_line_price, cart.currency)}</p>
            <div class="cart-drawer__item-qty">
              <button class="cart-drawer__qty-btn" data-drawer-qty-minus type="button" aria-label="Decrease quantity">−</button>
              <span class="cart-drawer__qty-num">${item.quantity}</span>
              <button class="cart-drawer__qty-btn" data-drawer-qty-plus type="button" aria-label="Increase quantity">+</button>
            </div>
          </div>
          <button class="cart-drawer__item-remove" data-drawer-remove type="button" aria-label="Remove ${escapeHtml(item.product_title)}">
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true">
              <line x1="1" y1="1" x2="11" y2="11" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/>
              <line x1="11" y1="1" x2="1" y2="11" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/>
            </svg>
          </button>
        </div>
        <hr class="cart-drawer__divider">
      `;
    });

    body.innerHTML = html;

    if (footer) {
      const subtotalEl = footer.querySelector('#CartDrawerSubtotal');
      if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price, cart.currency);
      footer.style.display = 'block';
    }
  }

  async function updateDrawerLine(lineIndex, quantity) {
    try {
      const res = await fetch(window.routes.cart_change_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: lineIndex, quantity: quantity })
      });
      if (res.ok) {
        const cart = await res.json();
        renderCartDrawer(cart);
        updateCartCount(cart.item_count);
      }
    } catch (err) {
      console.error(err);
    }
  }

  function initCartDrawer() {
    const drawer = document.getElementById('CartDrawer');
    if (!drawer) return;

    const closeBtn = drawer.querySelector('.cart-drawer__close');
    const overlay = drawer.querySelector('.cart-drawer__overlay');
    const body = document.getElementById('CartDrawerBody');

    if (closeBtn) closeBtn.addEventListener('click', closeCartDrawer);
    if (overlay) overlay.addEventListener('click', closeCartDrawer);

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeCartDrawer();
    });

    // Cart icon triggers drawer
    document.querySelectorAll('[data-cart-trigger]').forEach(trigger => {
      trigger.addEventListener('click', async (e) => {
        e.preventDefault();
        await fetchAndRenderCart();
        openCartDrawer();
      });
    });

    // Qty + remove via event delegation on drawer body
    if (body) {
      body.addEventListener('click', async (e) => {
        const item = e.target.closest('.cart-drawer__item');
        if (!item) return;
        const lineIndex = parseInt(item.dataset.lineIndex, 10);

        if (e.target.closest('[data-drawer-qty-minus]')) {
          const qtyEl = item.querySelector('.cart-drawer__qty-num');
          const current = parseInt(qtyEl.textContent, 10);
          await updateDrawerLine(lineIndex, Math.max(0, current - 1));
        } else if (e.target.closest('[data-drawer-qty-plus]')) {
          const qtyEl = item.querySelector('.cart-drawer__qty-num');
          const current = parseInt(qtyEl.textContent, 10);
          await updateDrawerLine(lineIndex, current + 1);
        } else if (e.target.closest('[data-drawer-remove]')) {
          await updateDrawerLine(lineIndex, 0);
        }
      });
    }
  }

  /* ============================================================
     Product Gallery
     ============================================================ */

  function initProductGallery() {
    const gallery = document.querySelector('.product-gallery');
    if (!gallery) return;

    const mainImg = gallery.querySelector('.product-gallery__main-image');
    const thumbs = gallery.querySelectorAll('.product-gallery__thumb');

    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        thumbs.forEach(t => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
        const img = thumb.querySelector('img');
        if (mainImg && img) {
          mainImg.src = img.src;
          if (img.srcset) mainImg.srcset = img.srcset;
        }
      });
    });

    if (thumbs.length > 0) thumbs[0].classList.add('is-active');
  }

  /* ============================================================
     Variant Picker (Product Page)
     ============================================================ */

  function initVariantPicker() {
    const picker = document.querySelector('.variant-picker');
    if (!picker) return;

    const options = picker.querySelectorAll('.variant-picker__option');
    const addToCartBtn = document.querySelector('.product-form__add-to-cart');
    const priceEl = document.querySelector('.product-details__price');
    const variantInput = document.querySelector('[name="id"]');
    const variantsData = window.productVariants || [];

    if (!options.length) return;

    options.forEach(opt => {
      opt.addEventListener('click', () => {
        if (opt.classList.contains('is-unavailable')) return;
        options.forEach(o => o.classList.remove('is-selected'));
        opt.classList.add('is-selected');

        const matchingVariant = findMatchingVariant(variantsData);
        if (matchingVariant && variantInput) {
          variantInput.value = matchingVariant.id;
          updatePrice(matchingVariant, priceEl);
          updateAvailability(matchingVariant, addToCartBtn);
        }
      });
    });
  }

  function findMatchingVariant(variants) {
    const selected = getSelectedOptions();
    return variants.find(v =>
      v.options.every((opt, i) => selected[i] === undefined || opt === selected[i])
    );
  }

  function getSelectedOptions() {
    const selected = [];
    document.querySelectorAll('[data-option-position]').forEach(group => {
      const active = group.querySelector('.variant-picker__option.is-selected');
      if (active) selected.push(active.dataset.value);
    });
    return selected;
  }

  function updatePrice(variant, priceEl) {
    if (!priceEl || !variant) return;
    const formatter = new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' });
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      priceEl.innerHTML = `
        <span class="price--sale">${formatter.format(variant.price / 100)}</span>
        <s class="price--was">${formatter.format(variant.compare_at_price / 100)}</s>
      `;
    } else {
      priceEl.innerHTML = `<span>${formatter.format(variant.price / 100)}</span>`;
    }
  }

  function updateAvailability(variant, btn) {
    if (!btn) return;
    if (variant.available) {
      btn.disabled = false;
      btn.textContent = window.cartStrings.addToCart || 'Add to Cart';
    } else {
      btn.disabled = true;
      btn.textContent = window.cartStrings.soldOut || 'Sold Out';
    }
  }

  /* ============================================================
     Add to Cart — Product Form
     ============================================================ */

  function initProductForm() {
    const form = document.querySelector('.product-form');
    if (!form) return;

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const variantId = form.querySelector('[name="id"]')?.value;
      const quantity = form.querySelector('[name="quantity"]')?.value || 1;
      if (!variantId) return;

      const btn = form.querySelector('.product-form__add-to-cart');
      if (btn) {
        btn.disabled = true;
        btn.textContent = 'Adding...';
      }

      await addToCart(variantId, quantity);

      if (btn) {
        btn.disabled = false;
        btn.textContent = window.cartStrings.addToCart || 'Add to Cart';
      }
    });
  }

  /* ============================================================
     Quick Add (Product Cards)
     ============================================================ */

  function initQuickAdd() {
    document.querySelectorAll('.product-card__quick-add').forEach(btn => {
      btn.addEventListener('click', async (e) => {
        e.preventDefault();
        e.stopPropagation();
        const variantId = btn.dataset.variantId;
        if (!variantId || btn.disabled) return;
        btn.textContent = 'Adding...';
        btn.disabled = true;
        await addToCart(variantId, 1);
        btn.textContent = 'Added!';
        setTimeout(() => {
          btn.textContent = btn.dataset.label || 'Quick Add';
          btn.disabled = false;
        }, 1500);
      });
    });
  }

  /* ============================================================
     Product Accordion
     ============================================================ */

  function initAccordion() {
    const items = document.querySelectorAll('.product-accordion__item');
    items.forEach(item => {
      const header = item.querySelector('.product-accordion__header');
      const body = item.querySelector('.product-accordion__body');
      if (!header || !body) return;

      header.addEventListener('click', () => {
        const isOpen = item.classList.contains('is-open');
        if (isOpen) {
          item.classList.remove('is-open');
          body.style.maxHeight = '0';
        } else {
          item.classList.add('is-open');
          body.style.maxHeight = body.scrollHeight + 'px';
        }
      });
    });

    if (items.length > 0) {
      const first = items[0];
      const firstBody = first.querySelector('.product-accordion__body');
      first.classList.add('is-open');
      if (firstBody) firstBody.style.maxHeight = firstBody.scrollHeight + 'px';
    }
  }

  /* ============================================================
     Size Guide Modal
     ============================================================ */

  function initSizeGuide() {
    const trigger = document.querySelector('[data-size-guide]');
    const modal = document.getElementById('SizeGuideModal');
    if (!trigger || !modal) return;

    const closeBtn = modal.querySelector('.sg-modal__close');
    const backdrop = modal.querySelector('.sg-modal__backdrop');

    function openModal() {
      modal.setAttribute('aria-hidden', 'false');
      modal.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      if (closeBtn) closeBtn.focus();
    }

    function closeModal() {
      modal.setAttribute('aria-hidden', 'true');
      modal.classList.remove('is-open');
      document.body.style.overflow = '';
      trigger.focus();
    }

    trigger.addEventListener('click', openModal);
    if (closeBtn) closeBtn.addEventListener('click', closeModal);
    if (backdrop) backdrop.addEventListener('click', closeModal);
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
    });
  }

  /* ============================================================
     Quantity Stepper (Product Page)
     ============================================================ */

  function initQuantityStepper() {
    const stepper = document.querySelector('.product-qty__stepper');
    if (!stepper) return;
    const input = stepper.querySelector('.product-qty__value');
    const minusBtn = stepper.querySelector('[data-qty-change="-1"]');
    const plusBtn = stepper.querySelector('[data-qty-change="1"]');

    function updateButtons() {
      const val = parseInt(input.value, 10) || 1;
      minusBtn.disabled = val <= 1;
      plusBtn.disabled = val >= 10;
    }

    minusBtn.addEventListener('click', () => {
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
      updateButtons();
    });

    plusBtn.addEventListener('click', () => {
      input.value = Math.min(10, (parseInt(input.value, 10) || 1) + 1);
      updateButtons();
    });

    input.addEventListener('change', () => {
      let val = parseInt(input.value, 10);
      if (isNaN(val) || val < 1) val = 1;
      if (val > 10) val = 10;
      input.value = val;
      updateButtons();
    });

    updateButtons();
  }

  /* ============================================================
     Newsletter Form
     ============================================================ */

  function initNewsletterForm() {
    document.querySelectorAll('.newsletter-form, .early-access__form').forEach(form => {
      form.addEventListener('submit', (e) => {
        const input = form.querySelector('input[type="email"]');
        if (!input || !input.value) {
          e.preventDefault();
          if (input) input.focus();
          return;
        }
        const btn = form.querySelector('button[type="submit"]');
        if (btn) {
          btn.disabled = true;
          btn.textContent = 'Joining...';
        }
      });
    });
  }

  /* ============================================================
     Cart Page — Quantity Controls
     ============================================================ */

  function initCartPage() {
    const cartItems = document.querySelectorAll('.cart-item');
    if (!cartItems.length) return;

    cartItems.forEach(item => {
      const qtyMinus = item.querySelector('[data-qty-minus]');
      const qtyPlus = item.querySelector('[data-qty-plus]');
      const qtyDisplay = item.querySelector('.cart-item__qty-num');
      const removeBtn = item.querySelector('.cart-item__remove');
      const lineIndex = item.dataset.lineIndex;

      if (qtyMinus) {
        qtyMinus.addEventListener('click', () => {
          const current = parseInt(qtyDisplay.textContent, 10);
          updateCartLine(lineIndex, current <= 1 ? 0 : current - 1);
        });
      }

      if (qtyPlus) {
        qtyPlus.addEventListener('click', () => {
          const current = parseInt(qtyDisplay.textContent, 10);
          updateCartLine(lineIndex, current + 1);
        });
      }

      if (removeBtn) {
        removeBtn.addEventListener('click', () => updateCartLine(lineIndex, 0));
      }
    });
  }

  async function updateCartLine(lineIndex, quantity) {
    try {
      const res = await fetch(window.routes.cart_change_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: lineIndex, quantity: quantity })
      });
      if (res.ok) window.location.reload();
    } catch (err) {
      console.error(err);
    }
  }

  /* ============================================================
     Scroll-based header shadow
     ============================================================ */

  function initHeaderScroll() {
    const header = document.querySelector('.site-header');
    if (!header) return;
    window.addEventListener('scroll', () => {
      header.style.boxShadow = window.scrollY > 80 ? '0 1px 0 rgba(0,0,0,0.08)' : 'none';
    }, { passive: true });
  }

  /* ============================================================
     Init
     ============================================================ */

  document.addEventListener('DOMContentLoaded', async () => {
    try {
      const cart = await fetchCart();
      updateCartCount(cart.item_count);
    } catch (e) { /* ignore */ }

    initCartDrawer();
    initProductGallery();
    initVariantPicker();
    initProductForm();
    initQuickAdd();
    initAccordion();
    initSizeGuide();
    initQuantityStepper();
    initNewsletterForm();
    initCartPage();
    initHeaderScroll();
  });

})();
